module.exports = __webpack_public_path__ + "static/media/bagy12.3b879f94.png";